<template>
    <transition name="overlay-fade">
        <div v-if="overlayUpdate" class="overlay-frost">
            <div class="overlay-panel">
                <loading-spinner :height="'56px'" :size="40" :width="3" no-margin-top />
                <div class="overlay-panel__title">{{ $t('common.download_update') }}</div>
                <div class="overlay-panel__subtitle">{{ $t('common.auto_reload') }}</div>
            </div>
        </div>
    </transition>
</template>

<script>

import {mapState} from 'vuex'
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    components: {LoadingSpinner},
    computed: {
        ...mapState(['overlayUpdate']),
    },
}
</script>

<style scoped>
.overlay-frost {
    position: fixed;
    inset: 0;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(6, 8, 12, 0.62);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

.overlay-fade-enter-active,
.overlay-fade-leave-active {
    transition: opacity 0.2s ease;
}

.overlay-fade-enter,
.overlay-fade-leave-to {
    opacity: 0;
}

.overlay-panel {
    width: 300px;
    max-width: calc(100vw - 48px);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 32px 28px;
    border-radius: 16px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.45);
}

.overlay-panel__title {
    margin-top: 20px;
    font-size: var(--fs-title);
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.overlay-panel__subtitle {
    margin-top: 6px;
    font-size: var(--fs-caption);
    color: var(--v-txtSecondary-base);
}
</style>
